import React, { FC, useEffect, useState } from 'react'
import { ListWidgetProps } from '../PageSectionForm.d'
import { Col, Form, InputGroup, Row } from 'react-bootstrap'
import RenderTranslatedFields from '../../../../common/forms/fields/translated-fields/RenderTranslatedFields'
import { urlTypes } from '../../../../common/Constants'

const ListWidget: FC<ListWidgetProps> = ({ formikProps, availablePages }) => {
    const { values, setFieldValue } = formikProps

    const [firstInternalPageId, setFirstInternalPageId] = useState<
        string | number | null
    >(null)

    useEffect(() => {
        const selectedVal = availablePages.filter((obj: any, index: number) => {
            return index === 0
        })

        setFirstInternalPageId(selectedVal[0]?.['id'] || '')
    }, [availablePages])

    return (
        <Row>
            <Col lg={12}>
                <RenderTranslatedFields
                    id="pageSectionListWidgetOptions"
                    formikProps={formikProps}
                    fields={[
                        {
                            id: 'formPageSectionListWidgetHeader',
                            type: 'text',
                            name: 'widget_header',
                            label: 'Header',
                            placeholder: 'Enter header',
                        },
                        {
                            id: 'formPageSectionListWidgetSubHeader',
                            type: 'text',
                            name: 'widget_sub_header',
                            label: 'Sub-Header',
                            placeholder: 'Enter sub-header',
                        },
                        {
                            id: 'formPageSectionListWidgetNoRecordsMessage',
                            type: 'text',
                            name: 'widget_no_records_message',
                            label: 'No Records Message',
                            placeholder: 'Enter message',
                        },
                    ]}
                />
            </Col>
            <Col lg={12} className="py-2">
                <Row className="align-items-center">
                    <Col md={4}>
                        <Form.Check
                            type="switch"
                            id="load-data-switch"
                            label="Load data"
                            className="align-middle"
                            defaultChecked={
                                values.widget_data?.['load_data'] || ''
                            }
                            onChange={(e) => {
                                setFieldValue('widget_data', {
                                    ...values.widget_data,
                                    load_data: e.target.checked,
                                })
                            }}
                        />
                    </Col>
                    <Col md={8}>
                        <Form.Group
                            as={Row}
                            className=""
                            controlId="formWidgetDataMaxNumOfRecords"
                        >
                            <Form.Label column sm={9} className="text-md-end">
                                Max number of records (1-50)
                            </Form.Label>
                            <Col sm={3}>
                                <Form.Control
                                    type="number"
                                    min={1}
                                    max={50}
                                    value={
                                        values.widget_data
                                            ?.client_module_filters?.[
                                            'max_num_of_records'
                                        ] || 1
                                    }
                                    disabled={
                                        !values.widget_data?.['load_data']
                                    }
                                    onChange={(e) => {
                                        setFieldValue('widget_data', {
                                            ...values.widget_data,
                                            client_module_filters: {
                                                ...values.widget_data
                                                    .client_module_filters,
                                                max_num_of_records:
                                                    e.target.value,
                                            },
                                        })
                                    }}
                                />
                            </Col>
                        </Form.Group>
                    </Col>
                    {values.widget_data?.['load_data'] && (
                        <Col lg={12}>
                            <fieldset className="mt-3">
                                <legend>More Button</legend>
                                <Form.Group
                                    className="my-3"
                                    controlId="widget_more_url_area"
                                >
                                    <InputGroup className="mb-3">
                                        <Form.Select
                                            value={
                                                values.widget_data?.[
                                                    'widget_more_target'
                                                ] || ''
                                            }
                                            style={{
                                                width: '30%',
                                            }}
                                            onChange={(e) => {
                                                setFieldValue('widget_data', {
                                                    ...values.widget_data,
                                                    widget_more_target:
                                                        e.target.value,
                                                    widget_more_page_sections_id:
                                                        firstInternalPageId,
                                                })
                                            }}
                                            required
                                        >
                                            {urlTypes.map((choice: any) => (
                                                <option
                                                    key={choice.id}
                                                    value={choice.id}
                                                >
                                                    {choice.name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        {!values.widget_data?.[
                                            'widget_more_target'
                                        ] ||
                                        values.widget_data?.[
                                            'widget_more_target'
                                        ] === 'internal' ? (
                                            <Form.Select
                                                value={
                                                    values.widget_data?.[
                                                        'widget_more_page_sections_id'
                                                    ] || ''
                                                }
                                                style={{
                                                    width: '70%',
                                                }}
                                                onChange={(e) => {
                                                    const urlId = parseInt(
                                                        e.target.value
                                                    )
                                                    const selectedVal =
                                                        availablePages.filter(
                                                            (obj: any) => {
                                                                return (
                                                                    parseInt(
                                                                        obj.id
                                                                    ) === urlId
                                                                )
                                                            }
                                                        )

                                                    const url =
                                                        selectedVal.length === 1
                                                            ? selectedVal[0][
                                                                  'code'
                                                              ]
                                                            : ''

                                                    setFieldValue(
                                                        'widget_data',
                                                        {
                                                            ...values.widget_data,
                                                            widget_more_url:
                                                                url,
                                                            widget_more_page_sections_id:
                                                                urlId,
                                                        }
                                                    )
                                                }}
                                                required
                                                data-validation-field-name="Url"
                                            >
                                                {availablePages.map(
                                                    (choice: any) => (
                                                        <option
                                                            key={choice.id}
                                                            value={choice.id}
                                                        >
                                                            {choice.name}
                                                        </option>
                                                    )
                                                )}
                                            </Form.Select>
                                        ) : (
                                            <Form.Control
                                                value={
                                                    values.widget_data?.[
                                                        'widget_more_url'
                                                    ] || ''
                                                }
                                                style={{
                                                    width: '70%',
                                                }}
                                                onChange={(e) => {
                                                    setFieldValue(
                                                        'widget_data',
                                                        {
                                                            ...values.widget_data,
                                                            widget_more_url:
                                                                e.target.value,
                                                        }
                                                    )
                                                }}
                                                required
                                                data-validation-field-name="Url"
                                            />
                                        )}
                                    </InputGroup>
                                </Form.Group>

                                <RenderTranslatedFields
                                    id="formWidgetDataMoreLabel"
                                    formikProps={formikProps}
                                    // groupClassName={
                                    //     formikProps.values.widget_data?.[
                                    //         'widget_more_target'
                                    //     ] === null ||
                                    //     formikProps.values.widget_data?.[
                                    //         'widget_more_target'
                                    //     ] === ''
                                    //         ? 'd-none'
                                    //         : ''
                                    // }
                                    fields={[
                                        {
                                            id: 'formWidgetDataMoreLabelInput',
                                            type: 'text',
                                            name: 'widget_more_label',
                                            label: 'More Label',
                                            placeholder: 'Enter label',
                                        },
                                    ]}
                                />
                            </fieldset>
                        </Col>
                    )}
                </Row>
            </Col>
            <hr />
            <h5 className="mb-3 text-info">Filters and conditions</h5>
            <Col lg={12}>
                <Form.Check
                    type="switch"
                    id="active-records-switch"
                    label="Active records only?"
                    defaultChecked={
                        values.widget_data.client_module_filters?.['active'] ||
                        ''
                    }
                    disabled={!values.widget_data?.['load_data']}
                    onChange={(e) => {
                        setFieldValue('widget_data', {
                            ...values.widget_data,
                            client_module_filters: {
                                ...values.widget_data.client_module_filters,
                                active: e.target.checked,
                            },
                        })
                    }}
                />
            </Col>
        </Row>
    )
}

export default ListWidget
